import React, { useEffect, useState } from "react";
import DTOLeaveAdvanceEncashmentARModal from "./DTOLeaveAdvanceEncashmentARModal";
import LeaveAdvanceEncashmentARModalPresenter from "./LeaveAdvanceEncashmentARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  leaveEncash_Data: any;
  leaveHistory?: any;
}

const LeaveAdvanceEncashmentARModalController = ({
  isModalOpen,
  closeModal,
  leaveEncash_Data,
  leaveHistory
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const [leaveEncashActions, setLeaveEncashActions] = useState([]);
  const { t } = useTranslation();

  const getLeavEncashAction = (data:any) =>{
    setLeaveEncashActions(data)
  }

  const handleAction = (payload: any) =>{

    actionRequiredService
    .finalActionSubmitActionRequired(payload)
    .then((res: any) => {
      if (res?.response === "success") {
        toast.success("Action Performed Successfully!");
        closeModal();
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.data);
    });
  }


  return (
    <div>
      <DTOLeaveAdvanceEncashmentARModal setActionsOfLeaveEncash={getLeavEncashAction} />

      <LeaveAdvanceEncashmentARModalPresenter
        full_data={leaveEncash_Data}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        leaveActions={leaveEncashActions}
        userId={selector.user_id}
        handleSubmitAR_Request={handleAction}
        historyData={leaveHistory}
      />
    </div>
  );
};

export default LeaveAdvanceEncashmentARModalController;
